import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { TennisBall, SignOut, Monitor, BoundingBox, UsersThree, ListChecks, Palette } from "@phosphor-icons/react";
import { useAuth } from "../context/AuthContext";
import CourtsPanel from "../components/admin/CourtsPanel";
import PlayersPanel from "../components/admin/PlayersPanel";
import MatchesPanel from "../components/admin/MatchesPanel";
import BrandingPanel from "../components/admin/BrandingPanel";

const TABS = [
  { key: "matches", label: "Partidos", icon: ListChecks },
  { key: "courts", label: "Canchas", icon: BoundingBox },
  { key: "players", label: "Jugadores", icon: UsersThree },
  { key: "branding", label: "Marca", icon: Palette },
];

export default function Admin() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [tab, setTab] = useState("matches");

  return (
    <div className="min-h-screen grain">
      {/* Header */}
      <header className="border-b border-white/10 bg-[#0A0A0C]/90 backdrop-blur sticky top-0 z-20">
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <TennisBall size={28} weight="fill" className="text-padel-green" />
            <span className="font-heading text-xl font-extrabold uppercase tracking-widest">Padel Live</span>
          </div>
          <div className="flex items-center gap-3">
            <a
              href="/display"
              target="_blank"
              rel="noreferrer"
              data-testid="open-display-btn"
              className="flex items-center gap-2 px-4 h-10 border border-padel-blue text-padel-blue font-heading uppercase text-sm tracking-widest hover:bg-padel-blue hover:text-black transition-colors"
            >
              <Monitor size={18} /> Pantalla
            </a>
            <span className="hidden sm:block text-sm text-muted-foreground">{user?.name}</span>
            <button
              data-testid="logout-btn"
              onClick={() => { logout(); navigate("/login"); }}
              className="p-2 text-muted-foreground hover:text-padel-danger transition-colors"
            >
              <SignOut size={20} />
            </button>
          </div>
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-6 py-8">
        {/* Tabs */}
        <div className="grid grid-cols-2 gap-2 mb-8 sm:flex sm:flex-wrap">
          {TABS.map((t) => {
            const Icon = t.icon;
            const active = tab === t.key;
            return (
              <button
                key={t.key}
                data-testid={`tab-${t.key}`}
                onClick={() => setTab(t.key)}
                className={`flex items-center justify-center gap-2 px-5 h-12 font-heading uppercase tracking-widest text-sm border transition-colors ${
                  active ? "bg-padel-blue text-black border-padel-blue" : "border-white/10 text-muted-foreground hover:border-white/30 hover:text-white"
                }`}
              >
                <Icon size={18} weight={active ? "fill" : "regular"} /> {t.label}
              </button>
            );
          })}
        </div>

        <div className={tab === "matches" ? "" : "hidden"}><MatchesPanel /></div>
        <div className={tab === "courts" ? "" : "hidden"}><CourtsPanel /></div>
        <div className={tab === "players" ? "" : "hidden"}><PlayersPanel /></div>
        <div className={tab === "branding" ? "" : "hidden"}><BrandingPanel /></div>
      </div>
    </div>
  );
}
